var map = {
	"./ar.json": "af08",
	"./chi.json": "1192",
	"./en.json": "edd4",
	"./fr.json": "f693",
	"./gr.json": "d9f9",
	"./hi.json": "7a03",
	"./ko.json": "dd11",
	"./sp.json": "f49a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";